export default __webpack_public_path__ + "static/media/trophy.966e8f12.svg";